export default {"src":"/_next/static/media/remote.487acaca.svg","height":779,"width":882};